module.exports = __webpack_public_path__ + "static/img/20012 (2).82e78a1.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20012 (2).webp
// module id = 6EHN
// module chunks = 14